import React, { useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import QuickActions from '../components/QuickActions';
import OfficeSpaces from '../components/OfficeSpaces';
import FlexibleWorkspace from '../components/FlexibleWorkspace';
import Benefits from '../components/Benefits';
import Amenities from '../components/Amenities';
import TrustedCompanies from '../components/TrustedCompanies';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <FlexibleWorkspace />
      <QuickActions />
      <OfficeSpaces />
      <Benefits />
      <Amenities />
      <TrustedCompanies />
      <Footer />
    </div>
  );
};

export default HomePage;